const tab_sections = {
    overview: 'Übersicht',
    resources: 'Ressourcen',
    users: 'Benutzer',
    access_control: 'Zugriffskontrolle',
    help_and_support: 'Hilfe und Support',
    tenant: 'Mieter',
    automation: 'Automatisierung',
};
export default Object.freeze(tab_sections);
